import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface ViewFullPageButtonProps {
  conversationId: string;
  /** Tenant primary color for the chip hover/border tint. Defaults to Spark Blue. */
  primaryColor?: string;
  /** Optional label override. Defaults to "View full page". */
  label?: string;
  className?: string;
}

/**
 * Shared chip that links to the dedicated /genie-hub/conversations/:id route.
 * Surfaces in both the side modal (next to Analyze + Mark Reviewed) and the
 * Insights expanded panel header. Stays out of the full-page route itself.
 */
export function ViewFullPageButton({
  conversationId,
  primaryColor = "#4E9CFF",
  label = "View full page",
  className,
}: ViewFullPageButtonProps) {
  return (
    <Link
      to={`/genie-hub/conversations/${conversationId}`}
      onClick={(e) => e.stopPropagation()}
      className={cn(
        "inline-flex items-center gap-1.5 px-3 py-2 text-xs sm:text-sm font-medium rounded-md border bg-white text-gray-700 hover:text-white transition-colors whitespace-nowrap",
        className,
      )}
      style={{
        borderColor: `${primaryColor}40`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = primaryColor;
        e.currentTarget.style.borderColor = primaryColor;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "";
        e.currentTarget.style.borderColor = `${primaryColor}40`;
      }}
    >
      <ExternalLink className="h-3.5 w-3.5" />
      <span>{label}</span>
    </Link>
  );
}
